import { UserApi, FeaturesApi } from 'api';
import { Api } from 'api/cabmun-api-public';

import camelcaseKeys from 'camelcase-keys';
import { useCallback, useState } from 'react';

const authConverter = (props: Api.CheckAuth200Response) => {
  return camelcaseKeys(props);
};
export type User = ReturnType<typeof authConverter>;

export const useAuth = () => {
  const [userData, setUserData] = useState<User | null>(null);
  const [pending, setPending] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [features, setFeatures] = useState<string[]>([]);

  const fetchUserData = useCallback(async () => {
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const userRaw = await UserApi.checkAuth();
      const user = authConverter(userRaw);
      setUserData(user);
      localStorage.setItem('display_name', user.displayName);
      setAuthorized(true);
      localStorage.setItem('UPR_logged', 'true');
    } catch (err) {
      setAuthorized(false);
      localStorage.setItem('UPR_logged', 'false');
    }
    setPending(false);
    setLoaded(true);
  }, [pending, setUserData, setPending, setAuthorized, setLoaded]);

  const fetchFeatures = useCallback(async () => {
    try {
      const res = await FeaturesApi.getListFeatures();
      setFeatures(res);
    } catch (e) {}
  }, []);

  return { userData, pending, authorized, loaded, fetchUserData, features, fetchFeatures };
};
